var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3347 8.02909C13.8692 7.95825 13.4558 8.27734 13.389 8.73225C13.2213 9.87484 12.694 10.9173 11.8639 11.7474C9.75127 13.8601 6.31627 13.8584 4.20443 11.7474C2.09302 9.63559 2.09302 6.19934 4.20443 4.08792C4.99868 3.29409 6.00135 2.7765 7.12352 2.58809C7.6061 2.4965 8.12493 2.48067 8.66327 2.54167C9.40243 2.62675 10.0904 2.872 10.7183 3.23209L9.63335 3.41734C9.1801 3.49509 8.87485 3.92559 8.95302 4.37925C9.02218 4.78534 9.3746 5.07217 9.77335 5.07217C9.81977 5.07217 9.86693 5.0685 9.91493 5.06034L12.8234 4.56309C13.0407 4.52567 13.2352 4.40359 13.363 4.22292C13.4908 4.04267 13.5413 3.81884 13.5038 3.60075L13.0057 0.692672C12.9292 0.239422 12.5043 -0.0641616 12.0438 0.0119218C11.5905 0.0896718 11.2853 0.520589 11.3634 0.974255L11.4945 1.73967C10.6879 1.28717 9.79818 0.994422 8.85285 0.885589C8.14485 0.805005 7.45802 0.827422 6.82935 0.947838C5.38202 1.19034 4.06693 1.86867 3.02602 2.90951C0.264766 5.67075 0.264766 10.1638 3.02602 12.9258C4.4066 14.3068 6.2206 14.9969 8.03418 14.9969C9.84818 14.9969 11.6613 14.3068 13.0423 12.9258C14.1272 11.8409 14.8173 10.4746 15.0378 8.97475C15.1046 8.519 14.7896 8.09575 14.3347 8.02909Z",
    fill: "#318BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9e41f6f927d4ebe7b5c004aabee87420.svg";
export { ForwardRef as ReactComponent };